import { IActionBase, IReportsState } from "../models/root.interface";

const initialState: IReportsState = {
    reports: [{
        id:1,title:"Month end report on SMS usage", titleDate:"01-08-2019 - 01-09-2019 (IST)", reqNumber:"+919963577364",reqDate:"20-Feb-2020, 1:30 AM",status:"Failed"
    },
    {
        id:2,title:"Month end report on SMS usage", titleDate:"01-08-2019 - 01-09-2019 (IST)", reqNumber:"+919963577364",reqDate:"20-Feb-2020, 1:30 AM",status:"Failed"
    },
    {
        id:3,title:"Month end report on SMS usage", titleDate:"01-08-2019 - 01-09-2019 (IST)", reqNumber:"+919963577364",reqDate:"20-Feb-2020, 1:30 AM",status:"Failed"
    }]
};
function reportsReducer(state: IReportsState = initialState, action: IActionBase): IReportsState {
    switch (action.type) {
        default:
            return state;
    }
}


export default reportsReducer;